import Pagination from "./page.vue";
/**
 * @type {import("vue").Component}
 * @description 表格控件
 */
const Grid = {
  name: "FGrid",
  inheritAttrs: false,
  props: {
    columns: { default: () => [], type: Array },
    data: { default: () => [], type: [Array, Function] },
    title: { type: String, default: "" }
  },
  render() {
    const { $scopedSlots: s, scopeData } = this;
    // 创建表格列
    const renderColumn = (columns = []) =>
      columns.map(({ children, ...col }) => {
        return (
          <ElTableColumn
            {...{
              attrs:
                col.type === "index"
                  ? Object.assign({ index: this.index }, col)
                  : col
            }}
          >
            {children?.length ? renderColumn(children) : s?.[col.prop]}
          </ElTableColumn>
        );
      });

    const MyTable = () => (
      <ElTable
        ref='table'
        class='jy-table'
        border
        data={this.list}
        height='100%'
        {...{
          attrs: this.$attrs,
          on: this.$listeners
        }}
      >
        {renderColumn(this.columns)}
      </ElTable>
    );

    const Title = () =>
      this.title && <div class='grid-title'>{this.title}</div>;
    const Head = () =>
      s.header && <div class='grid-header'>{s.header(scopeData)}</div>;
    const Content = () => (
      <div class='grid-content'>
        <MyTable />
      </div>
    );
    const Foot = () => (
      <div class='grid-footer'>
        <Pagination
          {...{
            on: {
              "page-change": this.search
            },
            attrs: {
              currentPage: this.page.pageNum,
              pageSize: this.page.pageSize,
              total: this.page.totalCount
            }
          }}
        />
      </div>
    );
    return (
      <div class='f-grid'>
        {/* 默认插槽 */}
        {this.$scopedSlots?.default?.(scopeData)}
        <Title />
        <Head />
        <Content />
        <Foot />
      </div>
    );
  },
  data() {
    return { list: [], page: { pageNum: 1, pageSize: 20, totalCount: 0 }};
  },
  computed: {
    scopeData() {
      return {
        search: this.search,
        page: {
          pageNum: this.page.pageNum,
          pageSize: this.page.pageSize
        }
      };
    },
    index() {
      return (this.page.pageNum - 1) * this.page.pageSize + 1;
    }
  },
  created() {
    this.search();
  },
  methods: {
    async search(pageNum = this.page.pageNum, pageSize = this.page.pageSize) {
      const page = { pageNum, pageSize };
      const fnOrList = this.data;
      // 拥有方法
      if (fnOrList?.call) {
        const res = await fnOrList(page);
        this.list = res.data;
        this.page.pageSize = res.pageSize;
        this.page.pageNum = res.pageNum || 1;
        this.page.totalCount = res.totalCount;
      } else if (fnOrList?.length) {
        this.list = fnOrList;
        this.page.pageNum = 1;
        this.page.totalCount = 0;
      }
      await this.$nextTick();
      this.$refs.table.doLayout();
    }
  }
};
export default Grid;
